import styles from "styles/Gallery.module.scss";
import {useState} from "react";

const Gallery = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState(null);

    const images = [
        { src: "/images/NEW.jpg", alt: "Foto 1" },
        { src: "/images/NEW1.jpg", alt: "Foto 2" },
        { src: "/images/NEW2.jpg", alt: "Foto 3" },
        { src: "/images/NEW3.jpg", alt: "Foto 4" },
        { src: "/images/NEW4.jpg", alt: "Foto 5" },
        { src: "/images/NEW5.jpg", alt: "Foto 6" },
        { src: "/images/NEW7.jpg", alt: "Foto 7" },
        { src: "/images/PHOTO-NEW.jpg", alt: "Foto 8" },
        { src: "/images/PHOTO-NEW1.jpg", alt: "Foto 9" },
        { src: "/images/galeria1.jpg", alt: "Foto 11" },
        { src: "/images/galeria2.jpg", alt: "Foto 12" },
        { src: "/images/Galleria3.jpg", alt: "Foto 13" },
        { src: "/images/PHOTO-2024-07-08-11-19-14.jpg", alt: "Foto 16" },
        { src: "/images/PHOTO-2024-07-12-16-38-25.jpg", alt: "Foto 17" },
        { src: "/images/PHOTO-2024-07-12-16-38-31.jpg", alt: "Foto 18" },
    ];

    const openModal = (image) => {
        setCurrentImage(image);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setCurrentImage(null);
    };

    return (
        <section className={styles.gallery}>
            <div className={styles.gridGallery}>
                {images.map((image, index) => (
                    <div
                        key={index}
                        className={`${styles.imageCard} ${styles[image.orientation]}`}
                        onClick={() => openModal(image)}
                    >
                        <img src={image.src} alt={image.alt} className={styles.galleryImage} />
                    </div>
                ))}
            </div>

            {isModalOpen && (
                <div className={styles.modal} onClick={closeModal}>
                    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <span className={styles.close} onClick={closeModal}>&times;</span>
                        <img src={currentImage.src} alt={currentImage.alt} className={styles.modalImage} />
                    </div>
                </div>
            )}
        </section>
    );
};

export default Gallery;
